var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.75C1 13.2312 2.20883 12 3.7 12C5.19117 12 6.4 13.2312 6.4 14.75V20.25C6.4 21.7688 5.19117 23 3.7 23C2.20883 23 1 21.7688 1 20.25V14.75Z",
    stroke: "#5E5E5E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 3.75C11.8 2.23122 13.0088 1 14.5 1C15.9912 1 17.2 2.23122 17.2 3.75V20.25C17.2 21.7688 15.9912 23 14.5 23C13.0088 23 11.8 21.7688 11.8 20.25V3.75Z",
    stroke: "#5E5E5E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 9.25C22.6 7.73122 23.8088 6.5 25.3 6.5C26.7912 6.5 28 7.73122 28 9.25V20.25C28 21.7688 26.7912 23 25.3 23C23.8088 23 22.6 21.7688 22.6 20.25V9.25Z",
    stroke: "#5E5E5E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.5d7285c922bdf07bcab1555cd365f1e7.svg";
export { ForwardRef as ReactComponent };